import { render, staticRenderFns } from "./InsolvencyPetitionApplications.vue?vue&type=template&id=52ecb15a&scoped=true&"
import script from "./InsolvencyPetitionApplications.vue?vue&type=script&lang=js&"
export * from "./InsolvencyPetitionApplications.vue?vue&type=script&lang=js&"
import style0 from "./InsolvencyPetitionApplications.vue?vue&type=style&index=0&id=52ecb15a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ecb15a",
  null
  
)

export default component.exports